module.exports = __webpack_public_path__ + "img/969-4c2acc.png";